import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { TypeCoreComponent } from 'src/app/pages/type-routes/type-core.component.js';

@Component({
	templateUrl: './ai.chat.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class AiChatComponent extends TypeCoreComponent implements OnInit {
	constructor() {
		super();

		this.dataInit = () => {};
	}
}
